export function hasChatDigitalData () {
  // eslint-disable-next-line no-prototype-builtins
  return window.localStorage.hasOwnProperty('chatDigitalData')
}

export function setChatDigitalData () {
  console.log('seeting chat digital data')
  const data = JSON.parse(window.localStorage.getItem('chatDigitalData'))
  // Set Medallia data layer
  window.digitalData.widgets.chat = window.digitalData.widgets.chat || {}
  window.digitalData.widgets.chat.customer = window.digitalData.widgets.chat.customer || {}
  window.digitalData.widgets.chat.customer.firstName = data.customer.firstName
  window.digitalData.widgets.chat.customer.lastName = data.customer.lastName
  window.digitalData.widgets.chat.customer.phone = data.customer.phone
  window.digitalData.widgets.chat.customer.email = data.customer.email
  window.digitalData.widgets.chat.customer.country = localStorage.getItem('country_code')
  window.digitalData.widgets.chat.question = data.question
  if (window.digitalData.products && window.digitalData.products.length > 0) {
    window.digitalData.widgets.chat.productName = window.digitalData.products[0].name
    window.digitalData.widgets.chat.sku = data.sku
  }
}

export function removeChatDigitalDataLocalStorage () {
  window.localStorage.removeItem('chatDigitalData')
}
